import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import cryptoWalletService from "@cryptoWalletService";

export function useFetchCryptoWallets() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['crypto_wallets', user?.id],
    queryFn: async () => {
      return await cryptoWalletService.fetchWallets(user!.id);
    },
    enabled: !!user,
  });
}

export function useCreateCryptoWallet() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (wallet: CryptoWalletCreateRequest) => {
      return await cryptoWalletService.createWallet(user!.id, wallet);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['crypto_wallets'] }),
  });
}

export function useDeleteCryptoWallet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return await cryptoWalletService.deleteWallet(id);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['crypto_wallets'] });
      qc.invalidateQueries({ queryKey: ['crypto_holdings'] });
    },
  });
}
